module.exports = __webpack_public_path__ + "static/media/litecoin.14d55368.svg";